(function () {
  var ROTATE_MS = 3200;
  var reducedMotion =
    typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.header-search-field--placeholder-animate').forEach(function (field) {
    var input = field.querySelector('input.field__input[type="search"]');
    var span = field.querySelector('.header-search__placeholder-text');
    if (!input || !span) return;

    var phrasesRaw = field.getAttribute('data-placeholder-phrases');
    var phrases = [];
    if (phrasesRaw) {
      try {
        phrases = JSON.parse(phrasesRaw);
      } catch (e) {
        phrases = [];
      }
    }
    if (!Array.isArray(phrases) || phrases.length === 0) {
      phrases = [span.textContent.trim()];
    }

    var rotateTimer = null;
    var phraseIndex = 0;

    function pause() {
      field.classList.add('is-placeholder-animation-paused');
      stopRotation();
      span.classList.remove('header-search__placeholder-slide');
      var normalLabel = field.getAttribute('data-default-search-label');
      if (normalLabel && span) {
        span.textContent = normalLabel;
      }
      if (input && normalLabel) {
        input.setAttribute('placeholder', normalLabel);
      }
    }

    function stopRotation() {
      if (rotateTimer !== null) {
        clearInterval(rotateTimer);
        rotateTimer = null;
      }
    }

    function startRotation() {
      stopRotation();
      if (reducedMotion || phrases.length <= 1 || field.classList.contains('is-placeholder-animation-paused')) {
        return;
      }
      rotateTimer = setInterval(function () {
        if (field.classList.contains('is-placeholder-animation-paused')) return;
        phraseIndex = (phraseIndex + 1) % phrases.length;
        span.classList.remove('header-search__placeholder-slide');
        span.textContent = phrases[phraseIndex];
        void span.offsetWidth;
        span.classList.add('header-search__placeholder-slide');
        if (input && !input.value) {
          input.setAttribute('placeholder', phrases[phraseIndex]);
        }
      }, ROTATE_MS);
    }

    input.addEventListener('focus', pause);
    input.addEventListener('pointerdown', pause);
    input.addEventListener('blur', function () {
      if (!input.value || !input.value.trim()) {
        field.classList.remove('is-placeholder-animation-paused');
        phraseIndex = 0;
        if (phrases.length) {
          span.textContent = phrases[0];
          input.setAttribute('placeholder', phrases[0]);
        }
        startRotation();
      }
    });

    if (field.classList.contains('header-search-field--placeholder-multiple')) {
      phraseIndex = 0;
      startRotation();
    }
  });
})();
